<template>
<div class="col-12" id="frame">
 
    <div class="alert alert-success" v-if="showAlarm">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>{{alarm}}</b>
      </span>
    </div>

          <div class="card col-md-6">          
            <div class="card-header text-xs-inline">
                <h4 class="card-title"> 
                    Packliste               
                </h4> 
                 <p class="card-category tablecard" id="subtitle">
                    Datum: {{bestellungen[0].Datum}}
                 </p>
                
            </div>

            <div class="card-body " id="cardbody" v-for="bestellung in bestellungen" v-bind:key="bestellung.Bestellnummer">
              
                  <span id="time">
								    <center> {{bestellung.Uhrzeit}} Uhr | {{bestellung.kunde}}
                </center><hr class="trennlinie">
                </span>
              
                <table v-if="bestellung.Selbsteinkaeufer == 1 || bestellung.Shop == 1">
                    <tr v-if="bestellung.Selbsteinkaeufer == 1">
                      <td><b>Selbsteinkäufer: </b></td>
                      <td>&nbsp;Ja</td>
                      <td class="buttonspalte">
                        <v-btn v-if="bestellung.SelbsteinkaeuferDone == 1" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.SelbsteinkaeuferDone, SelbsteinkaeuferDoneBez)">
                              <v-icon>check_circle</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.SelbsteinkaeuferDone == 0" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.SelbsteinkaeuferDone, SelbsteinkaeuferDoneBez)">
                              <v-icon>radio_button_unchecked</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    <tr v-if="bestellung.Shop == 1">
                      <td><b>Shop: </b></td>
                      <td>&nbsp;Ja</td>
                       <td class="buttonspalte">
                        <v-btn v-if="bestellung.ShopDone == 1" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.ShopDone, ShopDoneBez)">
                              <v-icon >check_circle</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.ShopDone == 0" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.ShopDone, ShopDoneBez)">
                              <v-icon>radio_button_unchecked</v-icon>
                        </v-btn>
                      </td>
                    </tr>                   
                </table>

                <div class="bemerkung" v-if="bestellung.Shop_Bemerkung">
                  Bemerkung:
                  {{bestellung.Shop_Bemerkung}}
                </div> 

                <hr class="linie" v-if="bestellung.Kisten == 1 || bestellung.Taschen == 1">   

                <table v-if="bestellung.Kisten == 1 || bestellung.Taschen == 1">
                    <tr v-if="bestellung.Kisten == 1">
                      <td><b>Kisten: &nbsp;</b></td>
                      <td v-if="bestellung.Kisten_anzahl">&nbsp;{{bestellung.Kisten_anzahl}}&nbsp;Stk.</td>
                      <td class="buttonspalte">
                        <v-btn v-if="bestellung.KistenDone == 1" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.KistenDone, KistenDoneBez)">
                              <v-icon >check_circle</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.KistenDone == 0" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.KistenDone, KistenDoneBez)">
                              <v-icon>radio_button_unchecked</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                     <tr v-if="bestellung.Taschen == 1">
                      <td><b>Taschen:&nbsp;&nbsp;</b></td>
                      <td v-if="bestellung.Taschen_anzahl">&nbsp;{{bestellung.Taschen_anzahl}}&nbsp;Stk.</td>
                      <td class="buttonspalte">
                        <v-btn v-if="bestellung.TaschenDone == 1" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.TaschenDone, TaschenDoneBez)">
                              <v-icon >check_circle</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.TaschenDone == 0" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.TaschenDone, TaschenDoneBez)">
                              <v-icon>radio_button_unchecked</v-icon>
                        </v-btn>
                      </td>
                    </tr> 

                </table>

                <hr class="liniesonder" v-if="bestellung.TK == 1"> 

                <table v-if="bestellung.TK == 1">
                    <tr>
                      <td><b>Tiefkühl:&nbsp;</b></td>
                      <td>Ja</td>
                      <td class="buttonspalte">
                        <v-btn v-if="bestellung.TKDone == 1" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.TKDone, TKDoneBez)">
                              <v-icon >check_circle</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.TKDone == 0" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.TKDone, TKDoneBez)">
                              <v-icon>radio_button_unchecked</v-icon>
                        </v-btn>
                      </td>
                    </tr>                  
                </table>

                <div class="bemerkung" v-if="bestellung.TK_Anmerkung">
                  Bemerkung:
                  {{bestellung.TK_Anmerkung}}
                </div> 

                <hr class="linie" v-if="bestellung.Baecker == 1">

                <table v-if="bestellung.Baecker == 1">
                    <tr>
                      <td><b>Bäcker:&nbsp;</b></td>
                      <td>Ja</td>
                      <td class="buttonspalte">
                        <v-btn v-if="bestellung.BaeckerDone  == 1" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.BaeckerDone, BaeckerDoneBez)">
                              <v-icon >check_circle</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.BaeckerDone  == 0" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.BaeckerDone, BaeckerDoneBez)">
                              <v-icon>radio_button_unchecked</v-icon>
                        </v-btn>
                      </td>
                    </tr>             
                </table>

                <div class="bemerkung" v-if="bestellung.Baecker_Bemerkung">
                      Bemerkung:
                      {{bestellung.Baecker_Bemerkung}}
                </div> 

                <hr class="linie" v-if="bestellung.Blumen == 1">

                <table v-if="bestellung.Blumen == 1">
                    <tr>
                      <td><b>Blumen:&nbsp;</b></td>
                      <td>Ja</td>
                      <td class="buttonspalte">
                        <v-btn v-if="bestellung.BlumenDone  == 1" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.BlumenDone, BlumenDoneBez)">
                              <v-icon >check_circle</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.BlumenDone  == 0" flat large icon color="grey" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.BlumenDone, BlumenDoneBez)">
                              <v-icon>radio_button_unchecked</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                </table>

                <div  class="bemerkung" v-if="bestellung.Blumen_Bemerkung">
                  Bemerkung:&nbsp;
                  {{bestellung.Blumen_Bemerkung}}
                </div> 

                  <div v-if="bestellung.Bestellbemerkung">
                    <hr class="linie">
                    
                    <div class="bemerkung" v-if="bestellung.Bestellbemerkung"> Bestellinformationen:{{bestellung.Bestellbemerkung}}</div>
                  </div> 

							<hr class="linie">

            </div>
          </div> 
        </div>
</template>

<script>
const moment = require('moment');
export default {
  data() {
    return {
       auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
       SelbsteinkaeuferDoneBez: "SelbsteinkaeuferDone",
       ShopDoneBez: "ShopDone",
       KistenDoneBez: "KistenDone", 
       TaschenDoneBez: "TaschenDone",  
       TKDoneBez: "TKDone", 
       BaeckerDoneBez: "BaeckerDone",
       BlumenDoneBez: "BlumenDone",
       bestellungen: [],
    //   title:"",
    //   kunde: {Nachname: "Dummy"},
    //   dialog: false,
    //   dialog1: false,
      alarm: "",
      showAlarm: false,
      kunde: "",
    //   kunde: {},
    //   zeit: "",
    //   datum:""
    
    };
  },
  methods: {
    changeStatus(bestellnr, stat, statusName){
      console.log(stat);
      	if (stat == 0) {
          stat = 1;
          for (var i=0 ; i < this.bestellungen.length ; i++){
            if (this.bestellungen[i].Bestellnummer == bestellnr) {
                this.bestellungen[i][statusName] = stat
            }
          }
        } else {
          stat = 0;
          for (var i=0 ; i < this.bestellungen.length ; i++){
            if (this.bestellungen[i].Bestellnummer == bestellnr) {
                this.bestellungen[i][statusName] = stat
            }
          }
        }
        let updatedStatus = {
           stat: stat,
           name: statusName
        }
        this.$http.put(process.env.VUE_APP_NODE_API_URL+"/heimspiel/updatestatus/"+bestellnr, updatedStatus, { headers: {'Authorization': this.auth }})
          .then(function(response) {
            console.log(response)
          });   
    },
  
    // gotoWaren(){
    //     this.$router.push('/waren/'+ this.bestellung.Kundennummer);
    // },
    // gotoPfand(){
    //     this.$router.push('/pfand/'+ this.bestellung.Kundennummer);
    // },
    createToday(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      var date = yyyy+ '-' + mm + '-' + dd;
      return date;
    },
    fetchTermine(){
        var today = this.createToday();
		this.$http.post(process.env.VUE_APP_PHP_API_URL+'/bestellungen/'+ today, {auth: process.env.VUE_APP_PHP_AUTH})
			.then(function(response){
        console.log(response)
        this.bestellungen = response.body;
        for(var i =0; i<this.bestellungen.length ; i++){
            
            this.bestellungen[i].Uhrzeit= this.bestellungen[i].Uhrzeit.substring(0,5);
            if (this.bestellungen[i].Firma.length < 2) {
          this.bestellungen[i].kunde = this.bestellungen[i].Nachname;
        }
        else{
          this.bestellungen[i].kunde = this.bestellungen[i].Firma;
        }
        }
        
        // this.datum = moment(this.bestellung.Datum, "LTS").format("LT");
        // this.zeit = this.bestellung.Uhrzeit.substring(0,5);

		// 		if (this.bestellung.Firma.length < 2) {
        //   this.title = this.bestellung.Nachname;
        // }
        // else{
        //   this.title = this.bestellung.Firma;
        // }
      });
      
      
    },
    // disableNotification(){
    //    this.showAlarm = !this.showAlarm;
    // },
    // gotoMaps(Strasse, Hausnummer, PLZ, Stadt) {
     
    //   window.location.href = "https://www.google.com/maps/dir/?api=1&destination=" + Strasse + "+"+ Hausnummer+ "+"+PLZ+"+" + Stadt+ "+Germany&travelmode=driving";
    // },
    // pushEdit(bestellnummer){
    //   this.$router.push('/editbestellung/'+ bestellnummer);
    // },
    // deleteBestellung(bestellnummer){

    //   this.$http.delete('https://api.uhl.katsios-kesting.de/bestellung/delete/'+ bestellnummer)
    //   .then(function(response) {
    //         this.$router.push({
    //           path: "/tagestour" ,
    //           query: { alarm: "Bestellung gelöscht!" }
    //         });
    //       });
    //   this.deleteTermin(this.bestellung.id, this.bestellung.kalender)
    // },
    // deleteTermin(terminId, kalender){
    //     this.$http.post('https://katsios-kesting.de:444/uhl/heimspiel/delete/termin', {id : terminId, type: kalender})
    //         .then(function(response){
    //             console.log(response);
    //         })
    // }
    
  },

  created: function(){
    this.fetchTermine();
    // if(this.$route.query.alarm){
    //   this.alarm = this.$route.query.alarm;
    //   this.showAlarm = true;
	//   }
  },
  components: {
    
  },
  // updated: function(){
  // }
};
</script>

<style scoped>

#phone{
  position: absolute;
  top: 15px;
  left: 15px;
}
#graphbutton{
padding: 0%;
margin: 0%;
}
#time{
  text-align: center;
  font-weight: bold;
  font-size: 120%;
  background-color: red;
 
}
#subtitle{
 padding-bottom: 20px;
 padding-left: 3px;
}
#frame{
  padding-left: 0px;
  padding-right: 0px;
}
.alert {
 border-radius: 7px 7px 7px 7px;
 text-align: center;
}
#cardbody{
   padding-top: 0%; 
}
.trennlinie{
  border: 1px solid red;
}
.buttonspalte{
  width: 100%;
}
.bemerkung{
  background-color: lightgray;
  border-radius: 4px;
  padding-left: 5px;
}
.liniesonder{
  margin: 0%;
}
.linie{
  margin-bottom: 0px;
  margin-top: 5px;
}
</style>